import { isUndNullEmp } from '../../helpers/main.js';

export class Role {
    constructor(
        _id = '',
        _name = '',
        _register = '',
    ) {
        this.id = _id;
        this.name = _name;
        this.register = _register;
    }

    static getClassName = () => {
        return 'Role - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 10,
                    Name: 10,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    Name: 256,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 10,
                    name: 10,
                    register: 10,
                },
                max: {
                    id: 450,
                    name: 256,
                    register: 30,
                },
            };
        }
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: Role.getClassName() })?.result) {
            if (upperCase) {
                return new Role(
                    obj.Id,
                    obj.Name,
                    obj.Register,
                );
            } else {
                return new Role(
                    obj.id,
                    obj.name,
                    obj.register,
                );
            }
        } else {
            return new Role();
        }
    }
}